import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7015db83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-overflow-x-hidden" }
const _hoisted_2 = {
  style: {"line-height":"22px"},
  class: "title tw-text-2xl tw-font-semibold tw-text-[#211F58] tw-text-[22px]"
}
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[15px]" }
const _hoisted_4 = { class: "table-content" }
const _hoisted_5 = { class: "organization-table" }
const _hoisted_6 = { class: "table-header tw-flex tw-flex-col md:tw-flex-row tw-gap-[10px] md:tw-items-center tw-justify-start md:tw-justify-between" }
const _hoisted_7 = { class: "sub-title tw-text-[18px] tw-font-semibold" }
const _hoisted_8 = { class: "group-button tw-flex tw-items-center" }
const _hoisted_9 = { class: "invited-table" }
const _hoisted_10 = { class: "table-header tw-flex tw-flex-col md:tw-flex-row tw-gap-[10px] md:tw-items-center tw-justify-start md:tw-justify-between" }
const _hoisted_11 = { class: "sub-title tw-text-[18px] tw-font-semibold" }
const _hoisted_12 = { class: "group-button tw-flex tw-items-center" }
const _hoisted_13 = { class: "tw-order-[1] md:tw-order-[2] tw-w-[100%] tw-flex tw-justify-center tw-rounded-br-md tw-rounded-bl-md tw-h-[fit-content] actionsWrapper tw-max-w-[241px] lg:tw-min-w-[241px]" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-gap-[40px] tw-flex-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "divider" }),
  /*#__PURE__*/_createElementVNode("div", { class: "tw-pb-[40px] tw-px-[40px] tw-flex tw-flex-col tw-gap-[40px] tw-w-full tw-h-[fit-content] avatarWrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-flex-1 tw-items-start tw-px-5 tw-max-w-[519.541px] custom-global-skeleton tw-h-[140px] tw-w-[0px] tw-rounded-[6px] tw-border-[#eff0f1]" })
  ])
], -1))

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import IconButton from "@/components/common/iconButton.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import store from "@/store";
import utilities, { getComponentUiText } from "@/utils/utilities";
import ProfileModal from "@/components/orgManagement/profileModal.vue";
import _ from "underscore";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import ManageUserModal from "@/components/orgManagement/manageUserModal.vue";
import MemberDetailsModal from "@/components/team/members/memberDetailsModal.vue";
import {
  MFAStatus,
  actionClickType,
  routers,
  statusCode,
  MODAL_NAME,
  localStorageKey,
} from "@/utils/constants";
import { IMemberInfo, IMemberOrganization } from "@/interfaces/members/IMember";
import {
  getExternalMembersOrg,
  getInternalMembersOrg,
  deactivateOrgMember,
  resetMFAOrgMember,
  deleteOrgExternalMember,
  deleteOrgMember,
  resetPasswordOrgMember,
  resetPasswordOrgMembers,
  resetMfaOrgMembers,
  postOrgMembersDeactivate,
  putOrgMembersActivate,
  deleteOrgMembersDelete,
  reactivateOrgMember,
  unlockOrgMember,
  mapDataInternalMembersList,
} from "@/services/org";
import userService from "@/services/user/userService";
import { IProfile } from "@/interfaces/members/IProfile";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import CustomTable, {
  CustomTableColumn,
} from "@/components/common/customTable.vue";
import StatusBadge from "@/components/common/setting/statusBadge.vue";
import TypeMfa from "@/components/common/setting/typeMfa.vue";
import CellTableInfo from "@/components/common/setting/cellTableInfo.vue";
import CellTableRoles from "@/components/common/setting/cellTableRoles.vue";
import CellTableAction from "@/components/common/setting/cellTableAction.vue";
import CheckListIcon from "@/components/svgs/checkListIcon.vue";
import AccessIcon from "@/components/svgs/accessIcon.vue";
import router from "@/router";
import { Ref, computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import BackgroundComponent from "@/components/common/backgroundComponent.vue";
import { IApiPromise } from "@/interfaces/responseData";
import { IModalMessage } from "@/interfaces/common/common";
import { number } from "joi";
import {
  getStatusMfa,
  _resetAuthenApp,
} from "@/utils/handleFunctionMemberManagement";
import MFASelectionModal from "@/components/team/members/mfaSelectionModal.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import ToggleSwitch from "@/components/common/toggleSwitch.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'membersManagement',
  setup(__props) {

const profileActions: Action[] = [
  {
    icon: CheckListIcon,
    title: "app-settings-team-members-right-actions-manage-roles-1",
    titleClass: "tw-max-w-[149px]",
    onClick: () => handleClickActionButton(routers.settingTeamRoles),
  },
  {
    icon: AccessIcon,
    title: "app-settings-team-members-right-actions-manage-access-1",
    titleClass: "tw-max-w-[149px]",
    onClick: () => handleClickActionButton(routers.settingOrgManageAccess),
  },
];
const isShowMoreActions = ref(false);
const isShowMoreActionsExternal = ref(false);

const externalMembersActions = [
  actionClickType.actionManageUser,
  actionClickType.actionRemoveAccess,
  actionClickType.actionEnableMFA,
];
const loadOrganizationMembers: Ref<boolean> = ref(true);
const loadInvitedMembers: Ref<boolean> = ref(true);
const isCheckCurrentUser = ref(false);
const fullNameUser = ref("");
const notInfoVisible = ref(true);
const currentUser = ref();
let organizationMembers: Ref<IMemberOrganization[]> = ref([]);
let invitedMembers: Ref<IMemberOrganization[]> = ref([]);
let memberInternalSelected: Ref<IMemberOrganization[]> = ref([]);
let memberExternalSelected: Ref<IMemberOrganization[]> = ref([]);
let isInternal = false;
let toastSuccess = "";
const isCloseModalProfile = computed(
  () => store.state.User.isCloseModalProfile,
);
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const currentUserInStore = computed(() => store.state.User.currentUser);
const organizationMembersTableFields: CustomTableColumn[] = [
  {
    text: getComponentUiText("app-component-custom-table-header-name-1"),
    value: "user",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
  },
  {
    text: getComponentUiText("app-settings-team-members-table-header-org-1"),
    value: "organization",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#212529] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-roles-1"),
    value: "roles",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-status-1"),
    value: "status",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-w-[70px]",
  },
  {
    text: getComponentUiText(
      "app-settings-team-members-table-header-last-active-1",
    ),
    value: "lastActive",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
  },
  {
    text: getComponentUiText(
      "app-settings-team-members-table-header-mfa-enable-1",
    ),
    value: "mfaEnabled",
    headerClass:
      "tw-text-[#878787] tw-w-[80px] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-pr-[16px]",
  },
];

const invitedMembersTableFields: CustomTableColumn[] = [
  {
    text: getComponentUiText("app-component-custom-table-header-name-1"),
    value: "user",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
  },
  {
    text: getComponentUiText("app-settings-team-members-table-header-org-1"),
    value: "organization",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#212529] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-roles-1"),
    value: "roles",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-min-w-[100px]",
    render: (value: string) =>
      `<span class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText(
      "app-settings-team-members-table-header-last-active-1",
    ),
    value: "lastActive",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase ",
  },
  {
    text: getComponentUiText(
      "app-settings-team-members-table-header-mfa-enable-1",
    ),
    value: "mfaEnabled",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-pr-[16px]",
  },
];

let isProfileModalVisible = ref(false);
const backgroundRef = ref(null);
const isShowArchived = ref(false);
const showModal = {
  showModalPassword: {
    value: ref(false),
    isMultiple: false,
  },
  showModalMFA: {
    value: ref(false),
    isMultiple: false,
  },
  showModalDeactivate: {
    value: ref(false),
    isMultiple: false,
  },
  showModalActivate: {
    value: ref(false),
    isMultiple: false,
  },
  showModalDelete: {
    value: ref(false),
    isMultiple: false,
  },
  showModalAddMember: {
    value: ref(false),
    isMultiple: false,
  },
  showModalUnlock: {
    value: ref(false),
    isMultiple: false,
  },
  showModalRemoveAccess: {
    value: ref(false),
    isMultiple: false,
  },
  showModalAddMFA: {
    value: ref(false),
    isMultiple: false,
  },
};
const currentOrg = computed(() => store.state.Org.currentOrg);

const profile: Ref<IProfile> = ref({
  fullName: "",
  title: "",
  company: "",
  email: "",
  roles: [],
  id: 0,
  mfaEnabled: "",
  isLocked: false,
  isDeactivated: false,
  status: "",
});

let existingProfile: Ref<IProfile> = ref({
  fullName: "",
  title: "",
  company: "",
  email: "",
  roles: [],
  id: 0,
  mfaEnabled: "",
  isLocked: false,
  isDeactivated: false,
  status: "",
});

onMounted(() => {
  EventEmitter.on("member-management-open-profile-modal", (member: any) => {
    const data = {
      ...member,
      user: {
        nameText: member.firstName + " " + member.lastName,
        title: member.title,
        email: member.email,
        imgSrc: "",
      } as IMemberInfo,
      status: member.isLocked
        ? statusCode.locked
        : member.isDeactivated
          ? statusCode.deactivated
          : statusCode.active,
      roles: member.roles || [],
      organization: member.org && member.org.orgNameShort,
      id: member.userId,
      mfaEnabled: member.mfaEnabled,
    };
    handleManageUser(data, "", true);
  });
  setTimeout(() => {}, 500);
  EventEmitter.on(EmitterEvents.RELOAD_MANAGE_MEMBERSHIPS, (isInternal) => {
    invitedMembers.value = [];
    organizationMembers.value = [];
    memberInternalSelected.value = [];
    memberExternalSelected.value = [];
    if (isInternal) {
      getInternalMembersList();
    } else {
      getExternalMembersList();
    }
    handleSelectMember([], true);
  });
  if (localStorage.getItem(localStorageKey.currentUserData)) {
    currentUser.value = JSON.parse(
      localStorage.getItem(localStorageKey.currentUserData) || "{}",
    );
  }
  existingProfile = ref({ ...profile.value });
  window.addEventListener("click", (e: any) => {
    if (!document.getElementById("clickbox-member")?.contains(e.target)) {
      (backgroundRef as any).animation &&
        (backgroundRef as any).animation.reloadToggle();
    }
  });
  // getExternalMembersList();
  // getInternalMembersList();

  EventEmitter.on(
    EmitterEvents.EXTERNAL_MEMBERS_LOADING_COMPLETED,
    (data: any) => {
      loadInvitedMembers.value = false;
      invitedMembers.value = data || [];
    },
  );

  EventEmitter.on(
    EmitterEvents.INTERNAL_MEMBERS_LOADING_COMPLETED,
    (data: any) => {
      loadOrganizationMembers.value = false;
      organizationMembers.value = data || [];
    },
  );

  EventEmitter.on(EmitterEvents.ORG_MEMBER_CREATED, (data: any) => {
    getInternalMembersList();
    setTimeout(() => {
      openAddOrgModal(data);
    }, 500);
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {});
  EventEmitter.off(EmitterEvents.RELOAD_MANAGE_MEMBERSHIPS);
  EventEmitter.off("member-management-open-profile-modal");
});

const getExternalMembersList = async () => {
  try {
    loadInvitedMembers.value = true;
    const res = await getExternalMembersOrg();
    if (res && res.data && res.data.data) {
      if (res.data.data.length > 0) {
        res.data.data = res.data.data.map((member) => {
          member = {
            ...member,
            user: {
              nameText: member.firstName + " " + member.lastName,
              title: member.title,
              email: member.email,
              imgSrc: "",
            },
            roles: member.roles || [],
            organization: member.org && member.org.orgNameShort,
            id: member.userId,
          };
          return member;
        });
      }

      invitedMembers.value = res.data.data;
      loadInvitedMembers.value = false;
    }
  } catch (error: any) {
    loadInvitedMembers.value = false;
    showErrorAPI(error, Org.getExternalMembersOfOrg);
  }
};

const organizationMembersList = computed(() => {
  return isShowArchived.value
    ? organizationMembers.value
    : organizationMembers.value.filter((member) => !member.isArchived);
});

const getInternalMembersList = async () => {
  try {
    loadOrganizationMembers.value = true;
    const res = await getInternalMembersOrg();
    if (res && res.data && res.data.data) {
      organizationMembers.value = mapDataInternalMembersList(res.data.data);
      loadOrganizationMembers.value = false;
    }
  } catch (error: any) {
    loadOrganizationMembers.value = false;
    if (error && error.data) {
      showErrorAPI(error, Org.getMembersOfOrg);
    }
  }
};

watch(currentOrg, (oldVal: any, newVal: any) => {
  if (oldVal && oldVal.name && newVal && newVal.name) {
    invitedMembers.value = [];
    organizationMembers.value = [];
    memberInternalSelected.value = [];
    memberExternalSelected.value = [];

    getExternalMembersList();
    getInternalMembersList();
    handleSelectMember([], true);
  }
});

watch(loadInvitedMembers, (oldVal: boolean, newVal: boolean) => {
  onPageCompleted();
});

watch(loadOrganizationMembers, (oldVal: boolean, newVal: boolean) => {
  onPageCompleted();
});

const onPageCompleted = () => {
  if (
    !loadInvitedMembers.value &&
    !loadOrganizationMembers.value &&
    isLoading.value
  ) {
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
  }
};

const handleManageUser = async (
  data: any,
  action: string,
  _isInternal: boolean,
) => {
  if (!action) {
    getRoleByUserId(data.userId);
  }
  isCheckCurrentUser.value = data?.userId === currentUser.value.userId;
  fullNameUser.value = `${data.firstName} ${data.lastName}`;
  isInternal = _isInternal;
  profile.value = {
    fullName: data.user.nameText || "",
    title: data.user.title || "",
    company: data.organization || "",
    email: data.user.email || "",
    roles: data.roles || [],
    profilePicture: data.user.imgSrc || "",
    lastActive: data.lastActive || "",
    id: data.userId || null,
    mfaEnabled: data.mfaEnabled || "",
    isLocked: data.isLocked || false,
    isDeactivated: data.isDeactivated || false,
    status: data.status || "",
  };

  existingProfile.value = { ...profile.value };
  toastSuccess = getComponentUiText(
    "app-settings-team-members-profile-toast-removed-all-access-1",
    false,
    { username: data.user.nameText },
  );

  if (
    action === actionClickType.actionAddAnotherMFA ||
    action === actionClickType.actionAddMFA
  ) {
    showModal.showModalAddMFA.value.value = true;
    return;
  }

  if (action === actionClickType.actionResetMFA) {
    const payload = {
      isCurrentUser: isCheckCurrentUser.value,
      user: currentUserInStore.value,
    };
    showMFA(payload);
    return;
  }

  if (action === actionClickType.actionResendInvite) {
    doResetPassword();
  }

  if (action === actionClickType.actionResetPassword) {
    const emitData = {
      component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
      properties: {
        value: {},
        title: getComponentUiText(
          "app-settings-team-members-profile-modal-pwd-action-title-1",
        ),
        description: getComponentUiText(
          "app-settings-team-members-profile-modal-pwd-action-current-user-1",
        ),
        buttonText: getComponentUiText(
          "app-settings-team-members-profile-modal-mfa-action-button-1",
        ),
        buttonRed: false,
        hiddenHelp: false,
        modalContainerClass: "tw-z-[1071]",
        updateDataFunction: () => {
          doResetPassword();
        },
      },
      events: {},
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  }

  if (action === actionClickType.actionRestoreUser) {
    await store.dispatch("Org/restoreUser", data.id);
    showSuccessToast(
      getComponentUiText("app-settings-org-profile-restore-user-success-1"),
    );
    getInternalMembersList();
  }

  if (action) {
    showModal[action] && (showModal[action].value.value = true);
    return;
  }

  openProfileModal();
};
const getRoleByUserId = (userId: string) => {
  try {
    store.dispatch("Org/getRoleByUserId", userId);
  } catch (error) {
    showErrorAPI(error, Org.getRoleByUserId);
  }
};
const handleSelectMember = (members: number[], isInternal = false) => {
  if (members.length < 1 && isInternal) {
    isShowMoreActions.value = false;
  }
  if (number.length < 1 && !isInternal) {
    isShowMoreActionsExternal.value = false;
  }
  if (isInternal) handleSelectInternalMember(members);
  else handleSelectExternalMember(members);
};

const handleSelectExternalMember = (ids: number[]) => {
  if (ids.length === 0) memberExternalSelected.value = [];
  else {
    const listSelected: IMemberOrganization[] = [];
    ids.forEach((id) => {
      const item = invitedMembers.value.find((x) => x.userId === id.toString());
      item && listSelected.push(item);
    });

    memberExternalSelected.value = listSelected;
  }
};

const resetMfaOtherUser = async () => {
  await new Promise((resolve) => setTimeout(resolve, 350));
  await ResetMFAUser(actionClickType.actionEnableMFA, false);
  // profile.value.id is id of the user
  // call api when click button reset When not current user
};
const resetMfaAuthenicator = () => {
  resetAuthenApp();
};

const resetMfaPasskey = async () => {
  try {
    await store.dispatch("Org/resetMembersMFAPasskey");
    const emitData: IToastMessage = {
      variant: ToastVariant.SUCCESS,
      message: getComponentUiText(
        "app-settings-team-members-toast-member-remove-mfa-successfully-1",
      ),
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    if (isInternal) {
      getInternalMembersList();
    } else {
      getExternalMembersList();
    }
    EventEmitter.emit(EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS);
  } catch (error: any) {
    showError(error?.data?.error?.message || "reset memberMFA error");
  }
};
const resetAuthenApp = async () => {
  const res = await _resetAuthenApp();
  if (res?.success) {
    isInternal ? getInternalMembersList() : getExternalMembersList();
    EventEmitter.emit(EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS);
  }
};

const modalConfig = {
  MFA_REGISTERED: {
    title: "app-settings-team-members-title-reset-authen-1",
    description: "app-settings-team-members-content-reset-authen-1",
    buttonText: "app-settings-team-members-profile-modal-pwd-action-button-1",
    onUpdate: resetAuthenApp,
  },
  MFA_REGISTERED_PK: {
    title: "app-settings-team-members-more-modal-reset-mfa-1",
    description: "app-user-setting-team-member-content-reset-mfa-register-pk-1",
    buttonText: "app-settings-team-members-reset-authen-button-1",
    submitButton: "app-settings-team-members-reset-passkey-button-1",
    onUpdate: resetMfaAuthenicator,
    onUpdate2: resetMfaPasskey,
  },
  MFA_REGISTERED_PKONLY: {
    title: "app-settings-team-members-reset-passkey-button-1",
    description: "app-user-setting-team-member-content-reset-pass-key-1",
    buttonText: "app-settings-team-members-profile-modal-pwd-action-button-1",
    onUpdate: resetMfaPasskey,
  },
};
const showMFA = (payload: {
  isCurrentUser: boolean;
  user: IMemberOrganization;
}) => {
  store.commit("User/setIsCloseModalProfile", false);
  const { isCurrentUser, user } = payload;
  if (isCurrentUser) {
    const config = modalConfig[profile.value.mfaEnabled];
    // const config = modalConfig["MFA_REGISTERED_PK"];
    if (config) {
      showModalBulkActions({
        ...config,
        buttonRed: true,
        hiddenHelp: false,
        userSelected: user,
      });
    }
  } else {
    showModalBulkActions({
      title: "app-settings-team-members-more-modal-reset-mfa-1",
      description:
        "app-user-setting-team-member-content-reset-mfa-not-current-user-1",
      buttonText: "app-settings-team-members-profile-modal-pwd-action-button-1",
      onUpdate: resetMfaOtherUser,
      buttonRed: true,
      hiddenHelp: false,
    });
  }
};

const handleSelectInternalMember = (ids: number[]) => {
  if (ids.length === 0) memberInternalSelected.value = [];
  else {
    const listSelected: IMemberOrganization[] = [];
    ids.forEach((id) => {
      const item = organizationMembers.value.find((x) => x.userId === id);
      item && listSelected.push(item);
    });

    memberInternalSelected.value = listSelected;
  }
};

const openProfileModal = () => {
  isProfileModalVisible.value = true;
};

const closeProfileModal = (checkDataChange = false) => {
  isProfileModalVisible.value = false;
  if (isCloseModalProfile.value) {
    if (!checkDataChange || _.isEqual(profile, existingProfile)) {
      profile.value = { ...existingProfile.value };
    }
  } else {
    (document.activeElement as HTMLElement).blur();
    document.body.focus();
  }
};

const handleShowModal = (action: string) => {
  store.commit("User/setIsCloseModalProfile", false);
  if (!action) return;
  if (
    action === actionClickType.actionAddAnotherMFA ||
    action === actionClickType.actionAddMFA
  ) {
    showModal.showModalAddMFA.value.value = true;
    return;
  }
  let emitData: IModalMessage = {
    component: "",
    properties: {},
    events: {},
  };
  switch (action) {
    case actionClickType.actionResetPassword:
      emitData = {
        component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
        properties: {
          value: {},
          title: getComponentUiText(
            "app-settings-team-members-profile-modal-pwd-action-title-1",
          ),
          description: getComponentUiText(
            "app-settings-team-members-profile-modal-pwd-action-current-user-1",
          ),
          buttonText: getComponentUiText(
            "app-settings-team-members-profile-modal-mfa-action-button-1",
          ),
          buttonRed: false,
          hiddenHelp: false,
          modalContainerClass: "tw-z-[1071]",
          updateDataFunction: () => {
            isProfileModalVisible.value = false;
            doResetPassword(actionClickType.actionResetPassword, false);
          },
        },
      };
      break;
  }
  if (emitData.component) {
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  }
  showModal[action] &&
    (showModal[action].value.value = true) &&
    (showModal[action].isMultiple = true);
};

const handleActionClick = (action: string, isMultiple = false) => {
  switch (action) {
    case actionClickType.actionResetPassword:
      doResetPassword(actionClickType.actionResetPassword, false);
      showModal[action].value.value = false;
      showModal[action].isMultiple = false;
      break;
    case actionClickType.actionEnableMFA:
      ResetMFAUser(actionClickType.actionEnableMFA, isMultiple);
      showModal.showModalMFA.value.value = false;
      showModal.showModalMFA.isMultiple = false;
      break;
    case actionClickType.actionActive:
      activeOrgMembers(actionClickType.actionActive, isMultiple);
      showModal[action].value.value = false;
      showModal[action].isMultiple = false;
      break;
    case actionClickType.actionDeactivate:
      deactivateUser(actionClickType.actionDeactivate, isMultiple);
      showModal[action].value.value = false;
      showModal[action].isMultiple = false;
      break;
    case actionClickType.actionDeleteUser:
      deleteUser(actionClickType.actionDeleteUser, isMultiple);
      showModal[action].value.value = false;
      showModal[action].isMultiple = false;
      break;
    case actionClickType.actionRemoveAccess:
      deleteExternalMember();
      showModal[action].value.value = false;
      showModal[action].isMultiple = false;
      break;
    case actionClickType.actionUnlockUser:
      unlockUser();
      showModal[action].value.value = false;
      showModal[action].isMultiple = false;
      break;
    default:
  }

  isProfileModalVisible.value = false;
};

const activeOrgMembers = async (action = "", isMultiple = false) => {
  try {
    let res;
    if (isMultiple) res = await doRequestMultipleEndPoint(action);
    res = await reactivateOrgMember(existingProfile.value.id);
    if (res && res.data) {
      refreshMemberData();
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-members-toast-member-activate-user-successfully-1",
        ),
      };

      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.putOrgMembersActivate);
    }
  }
};

const ResetMFAUser = async (action = "", isMultiple = false) => {
  try {
    let res;
    if (isMultiple) res = await doRequestMultipleEndPoint(action);
    else if (utilities.isEnableMFA(profile))
      res = await resetMFAOrgMember(profile.value.id);
    else res = await resetMFAOrgMember(profile.value.id);
    if (res && res.data) {
      refreshMemberData();
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-members-toast-member-remove-mfa-successfully-1",
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.postOrgMemberMfaEnable);
    }
  }
};

const deactivateUser = async (action = "", isMultiple = false) => {
  try {
    let res;
    if (isMultiple) res = await doRequestMultipleEndPoint(action);
    res = await deactivateOrgMember(existingProfile.value.id);

    if (res && res.data) {
      refreshMemberData();
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-members-toast-member-deactived-user-successfully-1",
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.deactivateOrgMember);
    }
  }
};

const deleteExternalMember = async () => {
  try {
    const res = await deleteOrgExternalMember(existingProfile.value.id);
    if (res && res.data) {
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: toastSuccess,
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
    getExternalMembersList();
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.deleteOrgExternalMember);
    }
  }
};

const deleteUser = async (action = "", isMultiple = false) => {
  try {
    if (isMultiple) await doRequestMultipleEndPoint(action);
    else await deleteOrgMember(existingProfile.value.id);
    const emitData: IToastMessage = {
      variant: ToastVariant.SUCCESS,
      message: getComponentUiText(
        "app-settings-team-members-toast-member-removed-successfully-1",
      ),
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    refreshData();
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.deleteOrgMember);
    }
  }
};

const unlockUser = async (action = "", isMultiple = false) => {
  try {
    const res = await unlockOrgMember(existingProfile.value.id);
    if (res && res.data) {
      refreshMemberData();
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-members-toast-member-unlocked-user-successfully-1",
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.deleteOrgMember);
    }
  }
};
const blockHover = () => {};

const openAddOrgModal = (data: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.VERIFY_ORG,
    properties: {
      orgName: data.nameShort ?? "",
      secretKey: data.secretKey,
      isVerifyOrg: true,
      firstName: data.firstName,
      lastName: data.lastName,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const openVerifyOrgModal = async (data: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_VERIFY_RESET_PASSWORD,
    properties: {
      orgName: data.nameShort ?? "",
      isCurrentUser: isCheckCurrentUser.value,
      secretKey: data.secret,
      fullName: fullNameUser.value,
    },
    events: {},
  };

  await new Promise((resolve) => setTimeout(resolve, 250));
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const secretRequiredPasswordReset = computed(
  () => store.state.Org.currentOrgSecretRequired?.secretRequiredPasswordReset,
);

const doResetPassword = async (action = "", isMultiple = false) => {
  try {
    let res: any;
    const recaptcha = await getRecaptcha();
    if (!isMultiple) {
      if (isCheckCurrentUser.value) {
        res = await userService.forgotPassword(profile.value.email, recaptcha);
      } else {
        res = await resetPasswordOrgMember(profile.value.id, recaptcha);
      }
    } else {
      res = await doRequestMultipleEndPoint(action);
    }

    const {
      data: {
        data: { secret },
      },
    } = res;

    if (res && res.data) {
      if (secretRequiredPasswordReset.value) {
        openVerifyOrgModal({ secret });
      }

      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-members-profile-toast-reset-password-1",
          false,
          { username: profile.value.fullName },
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    if (error === null) {
      store.commit("User/setErrorAnauth", true);
    }
    if (error && error.data) {
      showErrorAPI(error, Org.resetPasswordOrgMember);
    }
  }
};

const doRequestMultipleEndPoint = async (action) => {
  let res: IApiPromise<any>;
  const listSelected = isInternal
    ? memberInternalSelected
    : memberExternalSelected;

  if (listSelected.value.length > 0) {
    const ids = listSelected.value.map((x) => x.userId);
    switch (action) {
      case actionClickType.actionResetPassword:
        res = resetPasswordOrgMembers(ids);
        break;

      case actionClickType.actionEnableMFA:
        res = resetMfaOrgMembers(ids);
        break;

      case actionClickType.actionDeactivate:
        res = postOrgMembersDeactivate(ids);
        break;

      case actionClickType.actionActive:
        res = putOrgMembersActivate(ids);
        break;

      case actionClickType.actionDeleteUser:
        res = deleteOrgMembersDelete(ids);
        break;

      default:
        return null;
    }

    return res;
  }
  return null;
};

const addMember = () => {
  showModal.showModalAddMember.value.value = true;
};
const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
  if (memberInternalSelected.value.length < 1) {
    isShowMoreActions.value = false;
  }
};

const handleShowBulkActionExternal = () => {
  isShowMoreActionsExternal.value = !isShowMoreActionsExternal.value;
  if (memberExternalSelected.value.length < 1) {
    isShowMoreActionsExternal.value = false;
  }
};
//
const refreshData = () => {
  getExternalMembersList();
  getInternalMembersList();
};

const refreshMemberData = () => {
  if (isInternal) getInternalMembersList();
  else getExternalMembersList();
};

const closeNoteInfo = () => {
  notInfoVisible.value = false;
};

const handleClickActionButton = (routerUrl) => {
  router.push(routerUrl);
};

const showActiveDropdownBulkActions = (_isInternal = false) => {
  const listSelected = _isInternal
    ? memberInternalSelected.value
    : memberExternalSelected.value;
  if (listSelected.length === 0) return null;
  else {
    const itemDeactivate = listSelected.find(
      (i) => i.status !== statusCode.active,
    );
    const itemActive = listSelected.find((i) => i.status === statusCode.active);

    if (itemDeactivate && !itemActive) return false;
    else if (!itemDeactivate && itemActive) return true;
    else return null;
  }
};
const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const onResetMFA = async (data: {
  users: IMemberOrganization[];
  userIdsSelected: number[];
}) => {
  const { userIdsSelected } = data;
  try {
    await store.dispatch("Org/resetMembersMFA", { userIds: userIdsSelected });

    const emitData: IToastMessage = {
      variant: ToastVariant.SUCCESS,
      message: getComponentUiText(
        "app-settings-team-members-toast-member-reset-mfa-successfully-1",
      ),
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    getInternalMembersList();
  } catch (error: any) {
    showError(error?.data?.error?.message || "reset memberMFA error");
  }
};

const onReactivateMembers = async (data: {
  users: IMemberOrganization[];
  userIdsSelected: number[];
}) => {
  const { users, userIdsSelected } = data;
  try {
    await store.dispatch("Org/reactivateMembers", { userIds: userIdsSelected });
    const emitData: IToastMessage = {
      variant: ToastVariant.SUCCESS,
      message: getComponentUiText(
        "app-settings-team-members-toast-members-activate-user-successfully-1",
      ),
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    userIdsSelected.forEach((id) => {
      users.some((item) => {
        if (item.userId === id) {
          item.status = statusCode.active;
          return true;
        }
        return false;
      });
    });
  } catch (error: any) {
    showError(error?.data?.error?.message || "Reactivate error");
  }
};

const onDeactivateMembers = async (data: {
  users: IMemberOrganization[];
  userIdsSelected: number[];
}) => {
  const { users, userIdsSelected } = data;
  try {
    await store.dispatch("Org/deactivateMembers", { userIds: userIdsSelected });
    const emitData: IToastMessage = {
      variant: ToastVariant.SUCCESS,
      message: getComponentUiText(
        "app-settings-team-members-toast-members-deactived-user-successfully-1",
      ),
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    userIdsSelected.forEach((id) => {
      users.some((item) => {
        if (item.userId === id) {
          item.status = statusCode.deactivated;
          return true;
        }
        return false;
      });
    });
  } catch (error: any) {
    showError(error?.data?.error?.message || "Deactivate error");
  }
};

const onRemoveMembers = async (data: {
  users: IMemberOrganization[];
  userIdsSelected: number[];
  isExternal?: boolean;
}) => {
  const { users, userIdsSelected, isExternal } = data;
  try {
    await store.dispatch("Org/removeMembers", {
      userIds: userIdsSelected,
      isExternal,
    });
    const emitData: IToastMessage = {
      variant: ToastVariant.SUCCESS,
      message: getComponentUiText(
        "app-settings-team-members-toast-members-removed-successfully-1",
      ),
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    const newUsers = users.filter(
      (item) => !userIdsSelected.includes(item.userId),
    );
    if (isExternal) {
      invitedMembers.value = newUsers;
      memberExternalSelected.value = memberExternalSelected.value.filter(
        (user) => !userIdsSelected.includes(user.userId),
      );
    } else {
      organizationMembers.value = newUsers;
      memberInternalSelected.value = memberExternalSelected.value.filter(
        (user) => !userIdsSelected.includes(user.userId),
      );
    }
  } catch (error) {
    showErrorAPI(error, Org.deleteOneOrgMemberExternalDelete);
  }
};
const isMenuPin = computed(
  () =>
    store.state.Navigation.chevronActive && store.state.Navigation.isMenuOpen,
);

const showModalBulkActions = (data: {
  title: string;
  description: string;
  list?: string[];
  buttonText?: string;
  slotCustom?: any;
  onUpdate: (data: {
    users: IMemberOrganization[];
    userIdsSelected: number[];
    isExternal?: boolean;
  }) => void;
  onUpdate2?: (payload: any) => void;
  buttonRed?: boolean;
  isExternal?: boolean;
  hiddenHelp?: boolean;
  submitButton?: string;
  userSelected?: IMemberOrganization;
}) => {
  const memberList = data.isExternal
    ? memberExternalSelected.value
    : memberInternalSelected.value;
  const users = data.isExternal
    ? invitedMembers.value
    : organizationMembers.value;

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: data.title ? getComponentUiText(data.title) : "",
      description: data.description ? getComponentUiText(data.description) : "",
      list: memberList.map((item) => `${item.firstName} ${item.lastName}`),
      buttonText: data.buttonText ? getComponentUiText(data.buttonText) : "",
      buttonRed: !!data.buttonRed,
      slotCustom: data.slotCustom,
      hiddenHelp: data.hiddenHelp,
      submitButton: data.submitButton,
      modalContainerClass: "tw-z-[1071]",
      updateDataFunction: () => {
        data.onUpdate({
          users,
          userIdsSelected: memberList.map((item) => item.userId),
          isExternal: data.isExternal,
        });
      },
      updateDataFunction2: () =>
        data.onUpdate2?.({
          user: data.userSelected,
        }),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const getActionsData = (item: IMemberOrganization) => {
  let actions: any;
  if (item.isArchived) {
    return (actions = [actionClickType.actionRestoreUser]);
  }
  if (item.userId === currentUser.value.userId) {
    switch (item.mfaEnabled) {
      case MFAStatus.REGISTERED:
      case MFAStatus.REGISTERED_PK:
      case MFAStatus.REGISTERED_PKONLY: {
        actions = [
          actionClickType.actionManageUser,
          actionClickType.actionResetPassword,
          actionClickType.actionAddAnotherMFA,
          actionClickType.actionResetMFA,
          actionClickType.actionActive,
          actionClickType.actionUnlockUser,
        ];
        break;
      }
      case MFAStatus.NOT_REGISTERED:
      case MFAStatus.NOT_REQUIRED:
      default: {
        actions = [
          actionClickType.actionManageUser,
          actionClickType.actionResetPassword,
          actionClickType.actionAddMFA,
          actionClickType.actionActive,
          actionClickType.actionUnlockUser,
        ];
        break;
      }
    }
  } else {
    switch (item.mfaEnabled) {
      case MFAStatus.REGISTERED:
      case MFAStatus.REGISTERED_PK:
      case MFAStatus.REGISTERED_PKONLY: {
        actions = [
          actionClickType.actionManageUser,
          actionClickType.actionResetPassword,
          actionClickType.actionResetMFA,
          actionClickType.actionDeactivate,
          actionClickType.actionActive,
          actionClickType.actionDeleteUser,
          actionClickType.actionUnlockUser,
        ];
        break;
      }
      case MFAStatus.NOT_REGISTERED: {
        actions = [
          actionClickType.actionManageUser,
          actionClickType.actionResetPassword,
          actionClickType.actionEnableMFA,
          actionClickType.actionDeactivate,
          actionClickType.actionDeleteUser,
          actionClickType.actionUnlockUser,
        ];
        break;
      }
      case MFAStatus.NOT_REQUIRED:
      default: {
        actions = [
          actionClickType.actionManageUser,
          actionClickType.actionResetPassword,
          actionClickType.actionEnableMFA,
          actionClickType.actionDeactivate,
          actionClickType.actionActive,
          actionClickType.actionDeleteUser,
          actionClickType.actionUnlockUser,
        ];
        break;
      }
    }
  }
  if (item.status === statusCode.pending) {
    actions = [...actions, actionClickType.actionResendInvite];
  }
  return actions;
};

const getRecaptcha = async () => {
  try {
    const finalKey = await Utils.getV3Recaptcha();
    const recaptcha = await load(`${finalKey}`, {
      autoHideBadge: true,
    });
    const token = await recaptcha.execute("submit");
    return token;
  } catch (error: any) {
    router.push({ path: "/" });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(({ activeHierarchy }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern4, {
          ref: "animation",
          page: "APPBARLAYOUT"
        }, null, 512),
        _createVNode(BackgroundComponent, {
          ref_key: "backgroundRef",
          ref: backgroundRef
        }, null, 512),
        _createVNode(ActivePathWrapper, { "active-hierarchy": activeHierarchy }, null, 8, ["active-hierarchy"]),
        _createElementVNode("div", {
          style: `
            width: 100%;
            position: relative;
            z-index: 0;
            border-bottom: 1px solid #EFF0F1;
            `,
          class: _normalizeClass(`tw-my-0 tw-bg-[#fff] tw-py-[55px] xl:tw-px-[60px] tw-pl-[10px] xl:tw-pt-[55px] xl:tw-pb-[55px] tw-pr-[10px] tw-pt-[30px] tw-pb-[30px]  ${
            notInfoVisible.value ? 'not_notifiMember' : 'notifiMember'
          }`)
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getComponentUiText)(
                "app-settings-team-members-manage-member-title-1",
              )), 1),
          (notInfoVisible.value)
            ? (_openBlock(), _createBlock(NoteInfo, {
                key: 0,
                class: "custom-info tw-mt-[20px]",
                onClose: closeNoteInfo
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-settings-team-members-tip-top-text-1")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          id: "clickbox-member",
          class: _normalizeClass(`tw-mb-[0px] tw-pt-[55px] tw-pl-[60px] members-container ${
            isMenuPin.value ? 'members-container-pin' : ''
          }`)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`tw-gap-[60px]  content ${isMenuPin.value ? 'content-pin' : ''}`)
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                      "app-settings-team-members-manage-member-org-subtitle-1",
                    )), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "button-show-archived tw-p-4",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowArchived.value = !isShowArchived.value))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                          "app-manage-orgs-button-show-archived-1",
                        )), 1),
                      _createVNode(ToggleSwitch, {
                        "is-checked": isShowArchived.value,
                        color: "#2573E9",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                        "onUpdate:isChecked": _cache[1] || (_cache[1] = ($event: any) => (isShowArchived.value = $event))
                      }, null, 8, ["is-checked"])
                    ]),
                    _createElementVNode("div", { onClick: handleShowBulkAction }, [
                      _createVNode(ButtonBulkActions, {
                        "id-popover": 'popover-btn-bulk-actions-members-management',
                        active: _unref(memberInternalSelected).length >= 1,
                        class: _normalizeClass(`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`),
                        "show-more-actions": isShowMoreActions.value,
                        "show-acction-click": true,
                        "selected-number": _unref(memberInternalSelected).length
                      }, {
                        default: _withCtx(() => [
                          _createVNode(CustomDropDownItem, {
                            style: 'normal',
                            "id-text": 'app-settings-team-members-bulk-actions-modal-reset-mfa-1',
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (
                            showModalBulkActions({
                              title:
                                'app-settings-team-members-bulk-actions-modal-reset-mfa-title-1',
                              description:
                                'app-settings-team-members-bulk-actions-modal-reset-mfa-description-1',
                              buttonText:
                                'app-settings-team-members-bulk-actions-modal-reset-mfa-button-text-1',
                              buttonRed: true,
                              isExternal: false,
                              onUpdate: onResetMFA,
                            })
                          ))
                          }),
                          (showActiveDropdownBulkActions(true) === true)
                            ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                key: 0,
                                style: 'normal',
                                "id-text": 'app-settings-team-members-bulk-actions-item-deactivate-1',
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (
                            showModalBulkActions({
                              title:
                                'app-settings-team-members-bulk-actions-modal-deactivate-title-1',
                              description:
                                'app-settings-team-members-bulk-actions-modal-deactivate-description-1',
                              buttonText:
                                'app-settings-team-members-bulk-actions-modal-deactivate-button-text-1',
                              buttonRed: true,
                              isExternal: false,
                              onUpdate: onDeactivateMembers,
                            })
                          ))
                              }))
                            : _createCommentVNode("", true),
                          (showActiveDropdownBulkActions(true) === false)
                            ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                key: 1,
                                style: 'normal',
                                "id-text": 'app-settings-team-members-bulk-actions-item-reactivate-1',
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (
                            showModalBulkActions({
                              title:
                                'app-settings-team-members-bulk-actions-modal-reactivate-title-1',
                              description:
                                'app-settings-team-members-bulk-actions-modal-reactivate-description-1',
                              buttonText:
                                'app-settings-team-members-bulk-actions-modal-reactivate-button-text-1',
                              buttonRed: true,
                              isExternal: false,
                              onUpdate: onReactivateMembers,
                            })
                          ))
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(CustomDropDownItem, {
                            style: 'danger',
                            "id-text": 'app-settings-team-members-bulk-actions-item-remove-1',
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (
                            showModalBulkActions({
                              title:
                                'app-settings-team-members-bulk-actions-modal-remove-title-1',
                              description:
                                'app-settings-team-members-bulk-actions-modal-remove-description-1',
                              buttonText:
                                'app-settings-team-members-bulk-actions-modal-remove-button-text-1',
                              buttonRed: true,
                              hiddenHelp: false,
                              isExternal: false,
                              onUpdate: onRemoveMembers,
                            })
                          ))
                          })
                        ]),
                        _: 1
                      }, 8, ["active", "show-more-actions", "selected-number"])
                    ]),
                    _createVNode(ButtonFilter, {
                      active: false,
                      "id-popover": 'popover-btn-filter-members-management',
                      "is-margin-right": true
                    }),
                    _createVNode(IconButton, {
                      src: "/img/plus_icon.svg",
                      onClick: addMember
                    })
                  ])
                ]),
                _createVNode(CustomTable, {
                  columns: organizationMembersTableFields,
                  data: organizationMembersList.value,
                  "is-loading": loadOrganizationMembers.value,
                  "empty-text": 
                    _unref(getComponentUiText)(
                      'app-settings-team-members-table-empty-member-list-1',
                    )
                  ,
                  onUpdateSelectedRows: _cache[7] || (_cache[7] = ($event: any) => (handleSelectMember($event, true)))
                }, {
                  "cell(user)": _withCtx((data) => [
                    _createVNode(CellTableInfo, {
                      "data-cy": 'user-info',
                      value: data.value,
                      "is-current-user": data.item.userId === currentUser.value.userId,
                      "color-name": data.item.isArchived ? '#878787' : '#231f20'
                    }, null, 8, ["value", "is-current-user", "color-name"])
                  ]),
                  "cell(organization)": _withCtx((data) => [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                        data.item.isArchived
                          ? 'tw-text-[#878787]'
                          : 'tw-text-[#212529]'
                      , "tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]"])
                    }, _toDisplayString(data.value), 3)
                  ]),
                  "cell(roles)": _withCtx((data) => [
                    _createVNode(CellTableRoles, {
                      "color-role": data.item.isArchived ? '#878787' : '#212529',
                      value: data.value
                    }, null, 8, ["color-role", "value"])
                  ]),
                  "cell(status)": _withCtx((data) => [
                    (data.item.isArchived)
                      ? (_openBlock(), _createBlock(StatusBadge, {
                          key: 0,
                          value: 'archived',
                          "is-cursor-pointer": false
                        }))
                      : (_openBlock(), _createBlock(StatusBadge, {
                          key: 1,
                          value: data.value,
                          "is-cursor-pointer": false
                        }, null, 8, ["value"]))
                  ]),
                  "cell(mfaEnabled)": _withCtx((data) => [
                    _createVNode(TypeMfa, {
                      value: _unref(getStatusMfa)(data)
                    }, null, 8, ["value"])
                  ]),
                  "cell(action)": _withCtx((data) => [
                    _createVNode(CellTableAction, {
                      id: 'organization-table-' + data.idx,
                      "data-cy": 'action-button',
                      value: data,
                      "is-internal": true,
                      actions: getActionsData(data.item),
                      onManageUser: handleManageUser
                    }, null, 8, ["id", "value", "actions"])
                  ]),
                  _: 1
                }, 8, ["data", "is-loading", "empty-text"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getComponentUiText)(
                      "app-settings-team-members-manage-member-external-subtitle-1",
                    )), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", { onClick: handleShowBulkActionExternal }, [
                      _createVNode(ButtonBulkActions, {
                        "id-popover": 'popover-btn-bulk-actions-external-members-management',
                        active: _unref(memberExternalSelected).length >= 1,
                        "show-more-actions": isShowMoreActionsExternal.value,
                        "show-acction-click": true,
                        "selected-number": _unref(memberExternalSelected).length
                      }, {
                        default: _withCtx(() => [
                          _createVNode(CustomDropDownItem, {
                            style: 'danger',
                            "id-text": 'app-settings-team-members-bulk-actions-item-remove-1',
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (
                            showModalBulkActions({
                              title:
                                'app-settings-team-members-bulk-actions-modal-remove-title-1',
                              description:
                                'app-settings-team-members-bulk-actions-modal-remove-description-1',
                              buttonText:
                                'app-settings-team-members-bulk-actions-modal-remove-button-text-1',
                              buttonRed: true,
                              hiddenHelp: true,
                              isExternal: true,
                              onUpdate: onRemoveMembers,
                            })
                          ))
                          })
                        ]),
                        _: 1
                      }, 8, ["active", "show-more-actions", "selected-number"])
                    ]),
                    _createVNode(ButtonFilter, {
                      active: false,
                      "id-popover": 'popover-btn-filter-invited-members-management-2',
                      "is-margin-right": false
                    })
                  ])
                ]),
                _createVNode(CustomTable, {
                  columns: invitedMembersTableFields,
                  "is-loading": loadInvitedMembers.value,
                  data: _unref(invitedMembers),
                  "empty-text": 
                    _unref(getComponentUiText)(
                      'app-settings-team-members-table-empty-member-list-1',
                    )
                  ,
                  onUpdateSelectedRows: _cache[9] || (_cache[9] = ($event: any) => (handleSelectMember($event, false)))
                }, {
                  "cell(status)": _withCtx((data) => [
                    _createVNode(StatusBadge, {
                      value: data.value
                    }, null, 8, ["value"])
                  ]),
                  "cell(user)": _withCtx((data) => [
                    _createVNode(CellTableInfo, {
                      class: "tw-min-w-[160px]",
                      value: data.value,
                      "data-cy": 'user-info-external'
                    }, null, 8, ["value"])
                  ]),
                  "cell(roles)": _withCtx((data) => [
                    _createVNode(CellTableRoles, {
                      value: data.value
                    }, null, 8, ["value"])
                  ]),
                  "cell(mfaEnabled)": _withCtx((data) => [
                    _createVNode(TypeMfa, {
                      value: _unref(getStatusMfa)(data)
                    }, null, 8, ["value"])
                  ]),
                  "cell(action)": _withCtx((data) => [
                    _createVNode(CellTableAction, {
                      id: 'invited-table-' + data.idx,
                      "data-cy": 'action-button-invited',
                      value: data,
                      "is-internal": false,
                      actions: externalMembersActions,
                      onManageUser: handleManageUser
                    }, null, 8, ["id", "value"])
                  ]),
                  _: 1
                }, 8, ["is-loading", "data", "empty-text"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(ActionButton, { "profile-actions": profileActions })
            ])
          ], 2)
        ], 2),
        _createVNode(ProfileModal, {
          class: "tw-px-[0px]",
          "is-visible": _unref(isProfileModalVisible),
          profile: 
            currentUser.value?.userId === profile.value.id ? currentUserInStore.value : profile.value
          ,
          "is-internal": _unref(isInternal),
          "existing-profile": _unref(existingProfile),
          "is-current-user": currentUser.value?.userId === profile.value.id,
          onClose: closeProfileModal,
          onShowModal: handleShowModal,
          onShowModalMFA: showMFA
        }, null, 8, ["is-visible", "profile", "is-internal", "existing-profile", "is-current-user"]),
        _createVNode(ManageUserModal, {
          show: showModal.showModalDelete.value.value,
          header: false,
          "red-btn": true,
          "header-title": "app-settings-team-members-profile-modal-delete-action-warning-1",
          "contain-title": "app-settings-team-members-profile-modal-delete-action-title-1",
          "contain-sub-title": "app-settings-team-members-profile-modal-delete-action-helper-a-1",
          "action-title": "app-settings-team-members-profile-modal-delete-action-title-1",
          "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (showModal.showModalDelete.value.value = false)),
          "onUpdate:actionHandle": _cache[11] || (_cache[11] = ($event: any) => (
            handleActionClick(
              _unref(actionClickType).actionDeleteUser,
              showModal.showModalDelete.isMultiple,
            )
          ))
        }, null, 8, ["show"]),
        _createVNode(ManageUserModal, {
          show: showModal.showModalDeactivate.value.value,
          header: false,
          "red-btn": true,
          "contain-title": "app-settings-team-members-profile-modal-deactive-action-title-1",
          "contain-sub-title": "app-settings-team-members-profile-modal-deactive-action-helper-1",
          "action-title": "app-settings-team-members-profile-modal-deactive-action-title-1",
          "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (showModal.showModalDeactivate.value.value = false)),
          "onUpdate:actionHandle": _cache[13] || (_cache[13] = ($event: any) => (
            handleActionClick(
              _unref(actionClickType).actionDeactivate,
              showModal.showModalDeactivate.isMultiple,
            )
          ))
        }, null, 8, ["show"]),
        _createVNode(ManageUserModal, {
          show: showModal.showModalActivate.value.value,
          header: false,
          "red-btn": true,
          "contain-title": "app-settings-team-members-profile-modal-active-action-title-1",
          "contain-sub-title": "app-settings-team-members-profile-modal-active-action-helper-1",
          "action-title": "app-settings-team-members-profile-modal-active-action-title-1",
          "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => (showModal.showModalActivate.value.value = false)),
          "onUpdate:actionHandle": _cache[15] || (_cache[15] = ($event: any) => (
            handleActionClick(
              _unref(actionClickType).actionActive,
              showModal.showModalActivate.isMultiple,
            )
          ))
        }, null, 8, ["show"]),
        _createVNode(ManageUserModal, {
          show: showModal.showModalMFA.value.value,
          header: false,
          "red-btn": true,
          "contain-title": 'app-settings-team-members-profile-modal-mfa-action-title-1',
          "contain-sub-title": "app-settings-team-members-profile-modal-mfa-action-helper-1",
          "action-title": "app-settings-team-members-profile-modal-pwd-action-button-1",
          "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => (showModal.showModalMFA.value.value = false)),
          "onUpdate:actionHandle": _cache[17] || (_cache[17] = ($event: any) => (
            handleActionClick(
              _unref(actionClickType).actionEnableMFA,
              showModal.showModalMFA.isMultiple,
            )
          ))
        }, null, 8, ["show"]),
        _createVNode(ManageUserModal, {
          show: showModal.showModalRemoveAccess.value.value,
          header: false,
          "red-btn": true,
          "contain-title": "app-settings-team-members-profile-modal-actions-remove-all-access-1",
          "contain-sub-title": "app-settings-team-members-profile-modal-remove-access-action-helper-1",
          "action-title": "app-settings-team-members-profile-modal-remove-access-button-1",
          "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => (showModal.showModalRemoveAccess.value.value = false)),
          "onUpdate:actionHandle": _cache[19] || (_cache[19] = ($event: any) => (
            handleActionClick(
              _unref(actionClickType).actionRemoveAccess,
              showModal.showModalRemoveAccess.isMultiple,
            )
          ))
        }, null, 8, ["show"]),
        _createVNode(ManageUserModal, {
          show: showModal.showModalUnlock.value.value,
          header: false,
          "red-btn": true,
          "contain-title": "app-settings-team-members-profile-modal-actions-unlock-user-1",
          "contain-sub-title": "app-settings-team-members-profile-modal-unlock-user-action-helper-1",
          "action-title": "app-settings-team-members-profile-modal-unlock-user-button-1",
          "onUpdate:show": _cache[20] || (_cache[20] = ($event: any) => (showModal.showModalUnlock.value.value = false)),
          "onUpdate:actionHandle": _cache[21] || (_cache[21] = ($event: any) => (
            handleActionClick(
              _unref(actionClickType).actionUnlockUser,
              showModal.showModalUnlock.isMultiple,
            )
          ))
        }, null, 8, ["show"]),
        _createVNode(MFASelectionModal, {
          show: showModal.showModalAddMFA.value.value,
          "profile-data": profile.value,
          "off-event": !_unref(isProfileModalVisible),
          "is-internal": _unref(isInternal),
          "is-show-more-actions-external": isShowMoreActionsExternal.value,
          "onUpdate:show": _cache[22] || (_cache[22] = ($event: any) => (showModal.showModalAddMFA.value.value = false))
        }, null, 8, ["show", "profile-data", "off-event", "is-internal", "is-show-more-actions-external"]),
        _createVNode(MemberDetailsModal, {
          show: showModal.showModalAddMember.value.value,
          "onUpdate:show": _cache[23] || (_cache[23] = ($event: any) => (showModal.showModalAddMember.value.value = $event))
        }, null, 8, ["show"])
      ]),
      _hoisted_14
    ]),
    _: 1
  }))
}
}

})